// extracted by mini-css-extract-plugin
export default {"mainTitle":"CourseSectionTitle_mainTitle__-w5ZC"};